var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('div',{staticClass:"app-container"},[_c('router-view')],1):_c('div',{staticClass:"desktop-warning"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-box"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/darklogo.svg"),"alt":"Scanada Logo"}}),_c('p',[_vm._v("This app is only available on mobile devices.")])])
}]

export { render, staticRenderFns }